import React from 'react'

function StatusButton({ buttonText, handleClick }) {
  return (
    <button className="status-button" type="button" onClick={handleClick}>{buttonText}</button>
  )
}

export default StatusButton;